import { atom } from 'jotai';
import app from '@/utils/app';
import { store } from '@/state/store';

export type LocaleState = {
  language: string;
};

const initialState: LocaleState = {
  language: app.locale,
};

export const localeState = atom<LocaleState>(initialState);

export const language = atom((get) => get(localeState).language);

export function setLocaleState(state: LocaleState): void {
  store.set(localeState, state);
}

export function changeLanguage(language: string): void {
  setLocaleState({ language });
}

export default localeState;
